module.exports = __webpack_public_path__ + "img/banner-org.2615c127.png";